import { COLORS } from "./InFoGraphicFigure"

interface IFigureLineProps {
    id: string
    length: number
    i: number
    height: number
    gap: number
}
const FigureLine = (props : IFigureLineProps ) : JSX.Element => { 
    const height = props.height / props.length
    return <div className={`figure figure-${ props.id}`}>
        <div 
            className=""
            style={{
                height: height - props.gap,
                top: height * props.i, 
                overflow: "hidden"
            }}
        >
            <div 
                className={`info-graphics-figure `} 
                style={{
                    position: "absolute",
                    left:0,
                    top: - height * props.i,
                    background: COLORS[ props.i % COLORS.length  ]
                }}
            />
        </div>
    </div>
}

export default FigureLine